import { Tooltip } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import styles from "./filelistcenter.module.scss";
//import filegridimage from "../../../../styles/images/icon4.png";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconarrowlink from "../../../../styles/images/viewarrow.svg";
import iconnotsupport from "../../../../styles/images/hiddenimage.svg";
import { excelFormats, pptFormats, wordFormats, zipFormats,
  mp3Formats, pdfFormats, imageFormat, videoFormat, getFileSize } from '../../../../base/utils';
import moment from 'moment';
import { contactwindowDetails, initialStateModel, LoginState } from '../../../../models/model';
import { useSelector } from 'react-redux';
import { HighlightInner } from '../../rightsidebar/highlight';
import Lottie from 'lottie-react';
import NoContent from "../../../../shared/widgets/noContent";
import FileNoFound from "../../../../styles/images/empty_states/files_empty_state.svg";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";

type GridViewProps={
  fileslist:any;
  onclickgetId:Function;
  openShare:Function;
  openDelete:Function;
  downloadfiles:Function;
  viewinConversation:Function;
  onclickallfilegetId:Function;
  isSearch:boolean;
  searchWord:string;
}
type GridviewState ={
  fileslist:any;
}



export default function GridView({fileslist,isSearch,onclickgetId,openShare,openDelete,onclickallfilegetId,
  downloadfiles,viewinConversation,searchWord}:GridViewProps) {
  let { contactFileList, isContactFile }: contactwindowDetails =
    useSelector((state: initialStateModel) => state.contactWindowReducer);
  const [gridViewFiles, setgridViewFiles] = useState<GridviewState>({ fileslist: contactFileList });  
  const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const openFileimage=(file:any,messageBody?:any)=>{   
    if(imageFormat.includes(messageBody?.fileType) ){
      onclickgetId(file);
    }else{
      onclickallfilegetId(file);
    }
   
   
  };
  useEffect(() => {
    if(isSearch){
      setgridViewFiles({fileslist:fileslist});
    }else{
      setgridViewFiles({fileslist:contactFileList});
    }
    return () => {
      setgridViewFiles({fileslist:fileslist});
    };
  }, [fileslist,contactFileList]);

  const openshare=(file:any,messageBody?:any)=>{
    //const shareFileData = JSON.parse(file?.message?.body);    
    openShare(file);
  };
  const opendelete=(file:any)=>{
    openDelete(file);
  };
  const downloadAlfiles =(file:any)=>{
    downloadfiles(file);
  };
  const viewInConversation =(file:any)=>{
    viewinConversation(file);
  };
  const IsJsonString = (str:any)=>{
    try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
  };

  return (
    <div>
      {isContactFile &&  fileslist.length === 0 && gridViewFiles?.fileslist.length===0&& <NoContent image={FileNoFound}
          title={"Worktual files"}
          description={<>No files.</>} />}
         { !isContactFile && fileslist.length === 0 &&
          <Lottie className="svgLoading forchatsvg"
          animationData={ContactLoader} />}
    <div className={styles.filegridview}>
      <div className={styles.adjustcard}>
      { Array.isArray(gridViewFiles?.fileslist) && gridViewFiles?.fileslist.length>0 &&
       gridViewFiles?.fileslist?.map((file: any, i: number)=>{
        let messageBody = IsJsonString(file?.message?.body) ? JSON.parse(file?.message?.body) : file?.message?.body;
 
        let filePath = messageBody?.filePath;
        let fileType =messageBody?.fileType;
       let fileSize =messageBody?.filesize;
       let fileName =messageBody?.fileName;
       let isCloudfiles = messageBody?.isCloudfiles || false;
        return (
        <Fragment key={i}>   
          <div className={styles.filegridlist}>
            <div className={styles.fileImage}>
              
              {imageFormat.indexOf(fileType)  !== -1 && !isCloudfiles ?
                <img className={`${styles.posisetImg} ${styles.filegridimage}`} src={filePath}
                  onClick={()=>openFileimage(file,messageBody)} alt=""/>   
                  : 
                excelFormats.indexOf(fileType) !== -1  ?
                  <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconxls} alt=""
                    onClick={()=>openFileimage(file,messageBody)}
                  />:
                  videoFormat.indexOf(fileType) !== -1 && !isCloudfiles ?
                    <div className={styles.videoFiles}>
                    <video className="videoFluid" controls={true} preload="metadata">
                      <source onClick={()=>openFileimage(file)} src={messageBody?.filePath} type="video/mp4" />
                    </video>
                    <div className={styles.videoPlay}></div>
                  </div>:
                    mp3Formats.indexOf(fileType) !== -1  && !isCloudfiles ?
                      <img className={`${styles.filegridimage} ${styles.iconimages}`} src={iconmusic} alt=""
                        // onClick={()=>openFileimage(file,messageBody)} 
                        />:
                        pptFormats.indexOf(fileType) !== -1  ?
                          <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconppt} alt=""
                            onClick={()=> {isCloudfiles ? window.open(filePath) :openFileimage(file,messageBody)}}/>:
                          wordFormats.indexOf(fileType)  !== -1 ?
                            <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconword} alt=""
                            onClick={()=> {isCloudfiles ? window.open(filePath) :openFileimage(file,messageBody)}}/>:
                            zipFormats.indexOf(fileType)  !== -1 ?
                              <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconzip} alt=""
                                // onClick={()=>openFileimage(file,messageBody)}
                                />:
                                pdfFormats.indexOf(fileType) !== -1 ?
                                  <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconpdf} alt=""
                                  onClick={()=> {isCloudfiles ? window.open(filePath) :openFileimage(file,messageBody)}}/>
                                  :
                                  (imageFormat.indexOf(fileType)  !== -1 || videoFormat.indexOf(fileType) !== -1  || mp3Formats.indexOf(fileType) !== -1 )  &&  
                                  isCloudfiles ?
                                  <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconnotsupport} alt=""
                                  onClick={()=> {window.open(filePath)}} />  
                                  :
                                  <img className={`${styles.filegridimage} ${styles.posisetImg} ${styles.iconimages}`} src={iconnotsupport} alt=""
                                  onClick={()=> {window.open(filePath)}} />  
                }
              <div className={styles.hoverOptions}>
                <ul className={styles.hoverList}>
                  <Tooltip mouseEnterDelay={0.5} title='Download' className='cusTooltip' overlayClassName='customTooltip'>
                    <li><span className="icon_Downloadstroke"
                      onClick={()=>downloadAlfiles(file)}></span></li></Tooltip>
                  <Tooltip  mouseEnterDelay={0.5} title='Share' className='cusTooltip' overlayClassName='customTooltip'>
                    <li><span className="icon_reply"  onClick={()=>openshare(file)}></span>
                    </li></Tooltip>
                  <Tooltip  mouseEnterDelay={0.5} title='Conversation' className='cusTooltip' overlayClassName='customTooltip'>
                    <li><span className="icon_chat" onClick={()=>viewInConversation(file)}></span></li></Tooltip>
                  
                    {(window.location.pathname.includes('contact') && userdetails?.sip_login_id.toString() === file?.from?.toString() ? 
                      <Tooltip  mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                      <li><span className="icon_delete" onClick={()=>opendelete(file)}></span></li></Tooltip> :

                  window.location.pathname.includes('chat') && userdetails?.sip_login_id.toString() === file?.from?.toString()  &&
                    <Tooltip  mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                    <li><span className="icon_delete" onClick={() => opendelete(file)}></span></li></Tooltip> 
                  )}
                </ul>
              </div>
            </div>
            <div className={styles.expandconsec}>
                  <div className={styles.lefticnsec}>
                  <div className={styles.fileName}>
              <Tooltip mouseEnterDelay={0.5}  placement="top"
                title={messageBody.fileName } className='filetooltip'>
                <span className={styles.spanName}>
                <HighlightInner content={fileName}
                  searchedData={searchWord}></HighlightInner>
                </span>
                
              </Tooltip>
            </div>
            <div className={styles.fileinfo}>
              <tr>
                <td><span>{getFileSize(fileSize)}</span></td>
                <td>&nbsp;&nbsp;&nbsp;</td>
                <td>    <span> <HighlightInner content={moment(new Date(parseInt(file.timestamp))).format('ddd, MMM DD YYYY')}
                  searchedData={searchWord}></HighlightInner></span>  </td>
              </tr>
           
                  {isCloudfiles && <span>{filePath.includes('https://app.box.com') ? 'File from Box'  : "File from Drive"}</span> }
            </div>
             </div>
             {isCloudfiles && <div className={styles.rightimgside}>
              <img src= {iconarrowlink} alt =''/>
                </div>}
              </div>
           
            

          </div>
               
                 
        </Fragment>
           
       
         
       
      )})}
     
     </div>
    </div>
    </div>
  );
}

